import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  DateTime,
  TableCell,
  Text
} from 'components/common/Elements/Elements';
import Person from '../Person/Person';
import Os from '../Os/Os';
import { upFirstLetter, statusColor, underlineToSpace } from 'utils/common';
import classes from '../DevicesTable.module.scss';

const parsAttachedPolicy = (data, keyField) => {
  let req = '';
  if (data && data !== '-' && data !== 'NA' && data.length > 0) {
    data.map(
      item =>
        (req +=
          upFirstLetter(
            item[keyField] ? underlineToSpace(item[keyField]) : item
          ) + ', ')
    );
  } else return 'NA';
  return req.substring(0, req.length - 2);
};
const TableRow = ({ member, tableConf, row, mouseEnter }) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };
        return (
          <Fragment key={`${title}-${member.email}}`}>
            {show && field === 'firstName' && (
              <TableCell cellProps={cellProps}>
                <Person member={member} />
              </TableCell>
            )}
            {show && field === 'os' && (
              <TableCell cellProps={cellProps}>
                <Os os={member.os} osVersion={member.osVersion} />
              </TableCell>
            )}
            {show && field === 'osVersion' && (
              <TableCell cellProps={cellProps}>
                <Text className={classes.breakWord}>{member.osVersion}</Text>
              </TableCell>
            )}
            {show && field === 'deviceType' && (
              <TableCell cellProps={cellProps}>{member.deviceType}</TableCell>
            )}
            {show && field === 'appVersion' && (
              <TableCell cellProps={cellProps}>{member.appVersion}</TableCell>
            )}
            {show && field === 'lastDeviceLogin' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={member.lastDeviceLogin} />
              </TableCell>
            )}
            {show && field === 'postureCheckStatus' && (
              <TableCell cellProps={cellProps}>
                <div className={classes.notifWrap}>
                  {member.postureCheckStatus !== 'NA' && (
                    <div
                      className={classes.marker}
                      style={{
                        backgroundColor: statusColor(
                          (member.postureCheckStatus == 'Healthy'
                            ? 'True'
                            : 'False'
                          ).toLowerCase()
                        )
                      }}
                    />
                  )}
                  <Text className={classes.notif} weight="m">
                    {member.postureCheckStatus}
                  </Text>
                </div>
              </TableCell>
            )}
            {show && field === 'lastPostureCheckAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={member.lastPostureCheckAt} />
              </TableCell>
            )}
            {show && field === 'attachedPolicyProfileName' && (
              <TableCell cellProps={cellProps}>
                {parsAttachedPolicy(member.attachedPolicy, 'profileName')}
              </TableCell>
            )}
            {show && field === 'hostname' && (
              <TableCell cellProps={cellProps} isId>
                {member.hostname}
              </TableCell>
            )}
            {show && field === 'role' && (
              <TableCell cellProps={cellProps}>{member.role}</TableCell>
            )}
            {show && field === 'localeIdentifier' && (
              <TableCell cellProps={cellProps}>
                {member.localeIdentifier}
              </TableCell>
            )}
            {show && field === 'groups' && (
              <TableCell cellProps={cellProps}>
                {member.groups && Array.isArray(member.groups)
                  ? member.groups.join(', ')
                  : 'NA'}
              </TableCell>
            )}
            {show && field === 'idp' && (
              <TableCell cellProps={cellProps}>
                {member.idp && Array.isArray(member.idp)
                  ? member.idp.join(', ')
                  : 'NA'}
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  member: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  search: PropTypes.string,
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
